/**
 * @description Element Plus插件配置，用于全局配置Element Plus组件库
 */
import '@/assets/scss/element-plus.scss'
import ElementPlus from 'element-plus'
import setupElementIcon from './icon'
import '@/assets/scss/el-light.scss'
import '@/assets/scss/el-dark.scss'

export default function setupElementPlus(app) {
  setupElementIcon(app)
  app.use(ElementPlus)
}
